import { useState, useEffect } from 'react';
import { apiService } from '../services/api';

/**
 * Hook to fetch available markets from backend.
 * Returns markets that have at least one is_active symbol,
 * filtered by the current user's permissions.
 *
 * @param {Object} options
 * @param {boolean} options.includeAll - If true, prepends an "All Markets" option
 * @returns {{ marketOptions: Array, loading: boolean }}
 */
export default function useAvailableMarkets({ includeAll = false } = {}) {
  const [marketOptions, setMarketOptions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    apiService.getAvailableMarkets()
      .then(res => {
        const markets = res.data.markets || [];
        if (includeAll && markets.length > 0) {
          setMarketOptions([{ value: 'all', label: 'All Markets', icon: '🌍' }, ...markets]);
        } else {
          setMarketOptions(markets);
        }
      })
      .catch(() => {
        // Fallback if API fails
        setMarketOptions([
          { value: 'india', label: 'India', icon: '🇮🇳' },
          { value: 'us', label: 'US', icon: '🇺🇸' },
          { value: 'asia_pacific', label: 'Asia Pacific', icon: '🌏' },
          { value: 'europe', label: 'Europe', icon: '🇪🇺' },
          { value: 'crypto', label: 'Crypto', icon: '₿' },
          { value: 'precious_metals', label: 'Metals', icon: '🥇' },
        ]);
      })
      .finally(() => setLoading(false));
  }, [includeAll]);

  return { marketOptions, loading };
}
